import script from "./PerformerProjectFormStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep2.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep2.vue?vue&type=style&index=0&id=7298c5b3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7298c5b3"]])

export default __exports__